export const ROUTE_PREFIX = '/bbweb';

export const HOME_ROUTE = `${ROUTE_PREFIX}/home`;
export const LOGIN_ROUTE = `${ROUTE_PREFIX}/login`;
export const LOGOUT_ROUTE = `${ROUTE_PREFIX}/logout`;

// CLAUSES
export const CLAUSES_ROUTE = `${ROUTE_PREFIX}/clauses`;

// CONTRACTS
export const CONTRACTS_ROUTE = `${ROUTE_PREFIX}/contracts`;

// USERS
export const USERS_ROUTE = `${ROUTE_PREFIX}/users`;

// SETTINGS
export const SETTINGS_ROUTE = `${ROUTE_PREFIX}/settings`;

// TENANTS
export const TENANTS_NEW_ROUTE = `${ROUTE_PREFIX}/tenants/new`;
export const TENANT_DASHBOARD_ROUTE = `${ROUTE_PREFIX}/tenant-dashboard`;
export const LLM_STATS_ROUTE = `${ROUTE_PREFIX}/llm-stats`;
export const TEXT_INDEXER_URL = `${ROUTE_PREFIX}/textindexing/`;

// MODEL
export const MODEL_ROUTE = `${ROUTE_PREFIX}/model`;
export const MODEL_EDIT_ROUTE = `${ROUTE_PREFIX}/model/edit`;

// DOCSERVER
export const DOCSERVER_ROUTE = `${ROUTE_PREFIX}/oo`;
export const DOCSERVER_READONLY_ROUTE = `${ROUTE_PREFIX}/readonly`;

// ANALYTICS
export const ANALYTICS_ROUTE = `${ROUTE_PREFIX}/analytics`;

// FAST TRACK
export const FAST_TRACK_ROUTE = `${ROUTE_PREFIX}/ft`;

// POA
export const POA_ROUTE = `${ROUTE_PREFIX}/poa`;

// REPORTING ROUTE
export const REPORTING_ROUTE = `${ROUTE_PREFIX}/reporting`;

// ACCOUNT
export const ACCOUNT_ROUTE = `${ROUTE_PREFIX}/account`;

// INTEGRATIONS
export const INTEGRATIONS_ROUTE = `${ROUTE_PREFIX}/integrations`;

// SUBSCRIPTION
export const SUBSCRIPTION_UPGRADE_ROUTE = `${ROUTE_PREFIX}/subscription/upgrade`;
export const SUBSCRIPTION_MANAGE_ROUTE = `${ROUTE_PREFIX}/subscription/manage`;
